import { FadeUp } from "@/components/Reveal";

export default function Difference() {
  return (
    <section id="difference" className="bg-slate-900" data-testid="difference-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16 py-24 sm:py-28 lg:py-32">
        <FadeUp>
          <div
            className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-slate-500"
            data-testid="chapter-03"
          >
            <span className="h-px w-8 bg-slate-700" />
            <span>03 // Notre différence</span>
          </div>
        </FadeUp>
        <div className="mt-10 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-start">
          <FadeUp className="lg:col-span-6">
            <h2 className="w-full break-words whitespace-normal font-sans font-extrabold text-white text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight">
              L'investigation de gestion : bien au-delà du bilan comptable.
            </h2>
          </FadeUp>
          <FadeUp delay={0.15} className="lg:col-span-6">
            <p className="w-full break-words whitespace-normal text-base sm:text-lg text-slate-300 leading-relaxed">
              Les avocats, investisseurs et dirigeants ne peuvent se contenter d'une vision
              comptable figée. Qu'il s'agisse de traverser une zone de turbulences, de préparer
              une transmission (M&A) ou d'optimiser une exploitation, nous croisons
              l'investigation de vos données brutes avec l'analyse de votre environnement
              stratégique. Notre mission : décrypter la réalité des flux, modéliser la viabilité
              et vous livrer la matière première chiffrée indispensable pour sécuriser vos
              négociations et décisions critiques.
            </p>
            <p className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-slate-500">
              Investigation données (FEC) — Modélisation dynamique — Rapports d'aide à la décision
            </p>
          </FadeUp>
        </div>
      </div>
    </section>
  );
}
